module.exports = __webpack_public_path__ + "static/media/dashboardIcon.6dacc1c6.svg";